import { Component, Input, NgModule, NgModuleFactory, Compiler, ElementRef } from '@angular/core';
import { PageProvider } from '../../providers/page/page';
import { DirectivesModule } from '../../directives/directives.module';

// template: `<div class='fakebody'><div *ngIf="headerHtml !== ''" [innerHtml]="headerHtml"></div><div class='fakepage'><ng-container *ngComponentOutlet="dynamicComponent; ngModuleFactory: dynamicModule;"></ng-container></div><div *ngIf="footerHtml !== ''" [innerHtml]="footerHtml"></div></div>`
@Component({
  selector: 'co-pages',
  templateUrl: `co-pages.html`
})
export class CoPagesComponent {
  dynamicComponent;
  dynamicModule: NgModuleFactory<any>;

  @Input() id: number;
  title: string;
  articleHtml: string;
  headerHtml: string;
  footerHtml: string;
  @Input() className: string = "";
  @Input() cssRules: any = {};

  constructor(private pageProvider: PageProvider, private compiler: Compiler, private el: ElementRef) { }

  ngOnInit() {
    this.getPageHTML(this.id);
  }

  getPageHTML(id: number){
    this.pageProvider.getPageHTML(id).then((res) => {
      if(res.footerHtml) {
        this.footerHtml = res.footerHtml;
      }

      if(res.headerHtml){
        this.headerHtml = res.headerHtml;
      }

      this.articleHtml = res.articleHtml;
      this.title = res.title;
      // this.dynamicComponent = this.createNewComponent(this.articleHtml, this.className);
      // this.dynamicModule = this.compiler.compileModuleSync(this.createComponentModule(this.dynamicComponent));
    })
  }

  ngAfterViewInit(){
    if(this.cssRules){
      Object.keys(this.cssRules).forEach((key) => {
        let value = this.cssRules[key];
        this.el.nativeElement.style.setProperty(key, value, 'important');
      });
    }
  }

  protected createComponentModule (componentType: any) {
    @NgModule({
      imports: [DirectivesModule],
      declarations: [
        componentType
      ],
      entryComponents: [componentType]
    })
    class RuntimeComponentModule{
    }
    // a module for just this Type
    return RuntimeComponentModule;
  }

  protected createNewComponent (html, className) {
    let template = `<div class="${className}">${html}</div>`

    @Component({
      selector: 'dynamic-component',
      template: template
    })
    class DynamicComponent {
    }
    return DynamicComponent;
  }
}



// WEBPACK FOOTER //
// ./src/components/co-pages/co-pages.ts